import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    issueCardInfo,
    initialState,
} from 'app/core/models/slice/crd/issueCardInfo'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'issueCardInfo',
    initialState,
    reducers: {
        clearIssueCardInfo: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        setIssueCardInfo: (state, action: PayloadAction<issueCardInfo>) => {
            state = { ...action.payload }
        },
        setStudentCardYn: (state, action: PayloadAction<string>) => {
            state.studentCardYn = action.payload
        },
        setBrandNm: (state, action: PayloadAction<string>) => {
            state.brandNm = action.payload
        },
        setNewCard: (state, action: PayloadAction<string>) => {
            state.newCard = action.payload
        },
        setCcalCd: (state, action: PayloadAction<string>) => {
            state.ccalCd = action.payload
        },
        setHomeIssueCardInfo: (state, action: PayloadAction<issueCardInfo>) => {
            state.studentCardYn = action.payload.studentCardYn
            state.pdlnCd = action.payload.pdlnCd
            state.pdgrCd = action.payload.pdgrCd
            state.newCard = action.payload.newCard
        },
        setIssueCardInfoArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state[joinArr.key] = joinArr.value
            })
        },
        setIssueCardInfoObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const {
    clearIssueCardInfo,
    setIssueCardInfo,
    setStudentCardYn,
    setBrandNm,
    setNewCard,
    setCcalCd,
    setHomeIssueCardInfo,
    setIssueCardInfoArr,
    setIssueCardInfoObArr,
} = slice.actions

export default slice.reducer
